<script lang="ts">
	export let image: {
		src: string;
		alt: string;
	};

	export let loading: 'eager' | 'lazy' = 'eager';
</script>

<div
	class="relative mt-12 lg:mt-24 grid overflow-clip h-96 md:h-[31.25rem] rounded-3xl content-module-padding"
	{...$$restProps}
>
	<img
		src={image?.src}
		alt={image?.alt}
		{loading}
		class="absolute inset-0 w-full h-full object-cover"
	/>
</div>
